import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "apartment__thumb mr-3" }
const _hoisted_3 = { class: "plant-name mb-0" }
const _hoisted_4 = { class: "fs-18 text-gray" }
const _hoisted_5 = { class: "d-flex align-items-center mt-3" }
const _hoisted_6 = {
  key: 0,
  class: "connected-icon-wrapper"
}
const _hoisted_7 = { class: "connected-icon" }
const _hoisted_8 = { class: "fs-18 text-gray" }
const _hoisted_9 = { class: "apartment-dashboard" }
const _hoisted_10 = { class: "apartment-dashboard__main" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "mr-3" }
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = { class: "mx-3 center_title_cardcontainer" }
const _hoisted_15 = { class: "ml-2" }
const _hoisted_16 = { class: "ml-3" }
const _hoisted_17 = { class: "ml-2" }
const _hoisted_18 = { class: "list-blocks" }
const _hoisted_19 = { class: "apartment-dashboard__meta" }
const _hoisted_20 = { class: "apartment-meta__content" }
const _hoisted_21 = { class: "apartment-meta__head" }
const _hoisted_22 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_23 = { class: "apartment-meta__content" }
const _hoisted_24 = { class: "apartment-meta__head" }
const _hoisted_25 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_26 = { class: "list-bubbles list-bubbles--xs ml-auto" }
const _hoisted_27 = { class: "p-button p-button-rounded p-button-secondary fs-14" }
const _hoisted_28 = { class: "apartment-meta__content" }
const _hoisted_29 = { class: "apartment-meta__head" }
const _hoisted_30 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_31 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_32 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_33 = { class: "btn-stripped d-flex align-items-center" }
const _hoisted_34 = { class: "bt-icon bt-icon--sm mr-3 text-gray" }
const _hoisted_35 = { class: "apartment-meta__content" }
const _hoisted_36 = { class: "apartment-meta__head" }
const _hoisted_37 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }
const _hoisted_38 = { class: "bt-icon bt-icon--xs" }
const _hoisted_39 = { class: "ml-2" }
const _hoisted_40 = { class: "apartment-meta__content" }
const _hoisted_41 = { class: "apartment-meta__head" }
const _hoisted_42 = { class: "apartment-meta__icon bt-icon bt-icon--sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_EntrancePlantStatusBanner = _resolveComponent("EntrancePlantStatusBanner")
  const _component_Gate = _resolveComponent("Gate")
  const _component_CardContainer = _resolveComponent("CardContainer")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DialogAddEditGate = _resolveComponent("DialogAddEditGate")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode("img", {
            src: _ctx.imageURLs[0],
            srcset: _ctx.imageSrcSetURLs,
            alt: "img"
          }, null, 8, ["src", "srcset"])
        ]),
        _createVNode("div", null, [
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.currentEntrancePlant?.name), 1),
          _createVNode("address", _hoisted_4, _toDisplayString(_ctx.currentEntrancePlant.address) + ", " + _toDisplayString(_ctx.currentEntrancePlant.country), 1)
        ]),
        _renderSlot(_ctx.$slots, "head-menu")
      ]),
      _createVNode("div", _hoisted_5, [
        (_ctx.currentEntrancePlant.syncStatus?.connected)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_InlineSvgScoped, {
                  src: require(`@/assets/images/icon-check.svg`),
                  "aria-label": "icon-blueprint"
                }, null, 8, ["src"])
              ]),
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.Connected")), 1)
            ]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "update-time-meta")
      ])
    ]),
    (_ctx.currentEntrancePlant.syncStatus?.isPlantActive)
      ? (_openBlock(), _createBlock(_component_EntrancePlantStatusBanner, {
          key: 0,
          plant: _ctx.currentEntrancePlant,
          onUpdateList: _ctx.handleUpdateList
        }, null, 8, ["plant", "onUpdateList"]))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_9, [
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_CardContainer, {
          disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive || _ctx.noMoreScsAddresses,
          titleIcon: 
                    require('@/assets/images/entrancePlants/icon-gate.svg')
                ,
          title: `${_ctx.currentEntrancePlant.gates?.length ?? 0} ${_ctx.$t(
                    'AppResourceEP.Gates'
                )}`,
          showActionButton: !_ctx.adminView,
          onOnActionButtonClick: _ctx.toggleCreateGateDialog,
          actionButtonLabel: _ctx.$t('entrancePlant.addGate')
        }, _createSlots({
          default: _withCtx(() => [
            _createVNode("ul", _hoisted_18, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentEntrancePlant.gates, (gate, index) => {
                return (_openBlock(), _createBlock(_component_Gate, {
                  key: `${gate.gateId}-${index}`,
                  gate: gate,
                  plantId: _ctx.currentEntrancePlant.desktopId,
                  showActionButton: !_ctx.adminView,
                  disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                  onUpdateList: _ctx.handleUpdateList
                }, null, 8, ["gate", "plantId", "showActionButton", "disabled", "onUpdateList"]))
              }), 128))
            ])
          ]),
          _: 2
        }, [
          (_ctx.adminView)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _createVNode("h3", _hoisted_11, [
                    _createVNode("span", _hoisted_12, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                    require('@/assets/images/entrancePlants/icon-gate.svg')
                                
                      }, null, 8, ["src"]),
                      _createVNode("span", _hoisted_13, _toDisplayString(`${
                                        _ctx.currentEntrancePlant.gates?.length ?? 0
                                    } ${_ctx.$t("AppResourceEP.Gates")}`), 1)
                    ]),
                    _createVNode("span", _hoisted_14, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                    require('@/assets/images/entrancePlants/icon-building.svg')
                                
                      }, null, 8, ["src"]),
                      _createVNode("span", _hoisted_15, _toDisplayString(`${_ctx.countBuildings ?? 0} ${_ctx.$t(
                                        "AppResourceEP.Buildings"
                                    )}`), 1)
                    ]),
                    _createVNode("span", _hoisted_16, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                    require('@/assets/images/entrancePlants/icon-apartment.svg')
                                
                      }, null, 8, ["src"]),
                      _createVNode("span", _hoisted_17, _toDisplayString(`${_ctx.countApartments ?? 0} ${_ctx.$t(
                                        "AppResourceEP.Apartments"
                                    )}`), 1)
                    ])
                  ])
                ])
              }
            : undefined
        ]), 1032, ["disabled", "titleIcon", "title", "showActionButton", "onOnActionButtonClick", "actionButtonLabel"])
      ]),
      _createVNode("div", _hoisted_19, [
        _createVNode(_component_Card, {
          class: "apartment-meta card--slim",
          onClick: _ctx.goToAddressBook
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_20, [
              _createVNode("div", _hoisted_21, [
                _createVNode("span", _hoisted_22, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                        require('@/assets/images/entrancePlants/icon-resident.svg')
                                    ,
                    "aria-label": "icon-resident"
                  }, null, 8, ["src"])
                ]),
                _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.AddressBookResidents")), 1)
              ]),
              _createVNode(_component_Button, {
                onClick: _ctx.goToAddressBook,
                icon: "pi pi-chevron-right",
                class: "p-button-text p-button-secondary ml-2 ml-auto"
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Card, {
          class: "apartment-meta card--slim",
          onClick: _ctx.goToBadges
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode("span", _hoisted_25, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                        require('@/assets/images/entrancePlants/icon-badge.svg')
                                    ,
                    "aria-label": "icon-badge"
                  }, null, 8, ["src"])
                ]),
                _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.Badges")), 1)
              ]),
              _createVNode("div", _hoisted_26, [
                _createVNode("div", _hoisted_27, _toDisplayString(_ctx.countBadges), 1)
              ]),
              _createVNode(_component_Button, {
                icon: "pi pi-chevron-right",
                class: "p-button-text p-button-secondary",
                onClick: _ctx.goToBadges
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Card, { class: "apartment-meta card--slim" }, {
          content: _withCtx(() => [
            _createVNode(_component_ElDropdown, {
              trigger: "click",
              placement: "bottom-end",
              "popper-class": "el-dropdown__popper el-dropdown--context"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ElDropdownItem, { onClick: _ctx.goToGuests }, {
                      default: _withCtx(() => [
                        _createVNode("button", _hoisted_31, [
                          _createVNode("span", _hoisted_32, [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                                    require('@/assets/images/entrancePlants/icon-guest.svg')
                                                ,
                              "aria-label": "icon-guest"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Guests")), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_ElDropdownItem, { onClick: _ctx.goToMessages }, {
                      default: _withCtx(() => [
                        _createVNode("button", _hoisted_33, [
                          _createVNode("span", _hoisted_34, [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                                    require('@/assets/images/entrancePlants/icon-message.svg')
                                                ,
                              "aria-label": "icon-message"
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Messages")), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("span", _hoisted_30, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                            require(`@/assets/images/icons/icon-add.svg`)
                                        ,
                        "aria-label": "icon-additional-services"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.AdditionalServices")), 1)
                  ]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-right",
                    class: "p-button-text p-button-secondary ml-2 ml-auto"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (!_ctx.adminView)
          ? (_openBlock(), _createBlock(_component_Card, {
              key: 0,
              class: "apartment-meta card--slim",
              onClick: _ctx.goToSwitchboards
            }, {
              content: _withCtx(() => [
                _createVNode("div", _hoisted_35, [
                  _createVNode("div", _hoisted_36, [
                    _createVNode("span", _hoisted_37, [
                      _createVNode(_component_InlineSvgScoped, {
                        src: 
                                        require(`@/assets/images/entrancePlants/icon-switchboard.svg`)
                                    ,
                        "aria-label": "icon-switchboard"
                      }, null, 8, ["src"])
                    ]),
                    _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.Switchboard")), 1)
                  ]),
                  _createVNode(_component_Button, {
                    disabled: _ctx.NoSwitchboardAddresses,
                    class: "p-button-outlined p-button-rounded ml-auto",
                    onClick: _ctx.goToAddSwitchboard
                  }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_38, [
                        _createVNode(_component_InlineSvgScoped, {
                          src: 
                                        require(`@/assets/images/icons/icon-plus-outline.svg`)
                                    ,
                          "aria-label": "icon-plus-outline"
                        }, null, 8, ["src"])
                      ]),
                      _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-chevron-right",
                    class: "p-button-text p-button-secondary",
                    onClick: _ctx.goToSwitchboards
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Card, {
          class: "apartment-meta card--slim",
          onClick: _ctx.goToParametersSettings
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_40, [
              _createVNode("div", _hoisted_41, [
                _createVNode("span", _hoisted_42, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                        require('@/assets/images/entrancePlants/icon-parameters.svg')
                                    ,
                    "aria-label": "icon-parameters"
                  }, null, 8, ["src"])
                ]),
                _createVNode("h5", null, _toDisplayString(_ctx.$t("AppResourceEP.ParametersAndSettings")), 1)
              ]),
              _createVNode(_component_Button, {
                onClick: _ctx.goToParametersSettings,
                icon: "pi pi-chevron-right",
                class: "p-button-text p-button-secondary ml-2 ml-auto"
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createVNode(_component_DialogAddEditGate, {
      isVisible: _ctx.isAddGateDialogVisible,
      onHideDialog: _ctx.toggleCreateGateDialog,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "onHideDialog", "onUpdateList"])
  ], 64))
}